
export const LoginPage = class extends HTMLElement {
  recoverElem?: HTMLElement | null;
  loginElem?: HTMLElement | null;
  recoverBtnElem?: HTMLElement | null;
  recoverCancelBtnElem?: NodeListOf<Element>;
  recoverSuccess?: HTMLElement | null;

  constructor() {
    super();
    this.handleRecoverClick = this.handleRecoverClick.bind(this);
    this.handleRecoverCancel = this.handleRecoverCancel.bind(this);
  }

  connectedCallback() {
    this.recoverElem = document.querySelector("[data-recover]");
    this.loginElem = document.querySelector("[data-login]");
    this.recoverBtnElem = document.querySelector("[data-recover-btn]");
    this.recoverCancelBtnElem = document.querySelectorAll("[data-recover-cancel]");
    this.recoverSuccess = document.querySelector("[data-recover-success]");

    this.recoverBtnElem?.addEventListener("click", this.handleRecoverClick);
    this.recoverCancelBtnElem?.forEach(elem => elem.addEventListener("click", this.handleRecoverCancel));

    const isRecover = !!this.recoverSuccess || window.location.hash === "#recover";
    this.toggleView(isRecover);
  }

  disconnectedCallback() {
    this.recoverBtnElem?.removeEventListener("click", this.handleRecoverClick);
    this.recoverCancelBtnElem?.forEach(elem => elem.removeEventListener("click", this.handleRecoverCancel));
  }

  handleRecoverClick() {
    this.toggleView(true);
    setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 200);
  }

  handleRecoverCancel() {
    this.toggleView(false);
    setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 200);
  }

  toggleView(isRecover: boolean) {
    if (isRecover) {
      this.recoverElem?.classList.remove("hidden");
      this.loginElem?.classList.add("hidden");
    } else {
      this.recoverElem?.classList.add("hidden");
      this.loginElem?.classList.remove("hidden");
    }
  }
};

customElements.define("login-page", LoginPage);
